import { useMainStore } from '@/stores/store.js';

/**
 * Controleert of de huidige workspace alle gevraagde modules heeft.
 *
 * @param {string[]} required - Array van module-namen om op te checken.
 * @returns {boolean}         - true als alle modules aanwezig zijn, anders false.
 */
export function checkSubscription(required) {
    const store = useMainStore();
    const modules = Array.isArray(store.workspace?.subscription?.modules)
      ? store.workspace.subscription.modules
      : [];
    return required.every((mod) => modules.includes(mod));
  }